import { RadioButtonGroupLayout } from 'framework/ui/layout';
import { Dropdown } from 'framework/form';
import { FillInputProps } from '../fillInput';
import { inRow } from '../shared/choice';

export interface SelectSettings {
  display?: 'select' | 'radioButtons';
}

type SelectInputProps = FillInputProps<string | null, SelectSettings>;

export const SelectInput = (props: SelectInputProps) => {
  return props.settings.display === 'radioButtons' ? <SelectRadioButtons {...props} /> : <SelectDropdown {...props} />;
};

const SelectDropdown = (props: SelectInputProps) => {
  const { options, value, onChange, onBlur, inputId, label, showLabel, disabled, required, error } = props;
  return (
    <Dropdown
      {...props}
      source={inputId}
      label={showLabel ? label : ''}
      options={options.map(option => ({ value: option.id, label: option.label }))}
      value={value ?? ''}
      onChangeCallback={values => onChange(values[inputId] || null)}
      validationCallback={onBlur}
      placeholder="Select..."
      disabled={disabled}
      isRequired={required}
      errorMessages={error ? [''] : []}
      sx={{ mb: 0 }}
    />
  );
};

const SelectRadioButtons = (props: SelectInputProps) => {
  const { options, value, onChange, inputId, labelId, describedBy } = props;
  const { disabled, required, error } = props;
  return (
    <RadioButtonGroupLayout
      source={inputId}
      options={options.map(option => ({ value: option.id, label: option.label }))}
      isColumnDirection={!inRow(options)}
      value={value ?? ''}
      onChangeCallback={values => onChange(values[inputId])}
      disabled={disabled}
      isRequired={required}
      errorMessages={error ? [''] : []}
      aria-labelledby={labelId}
      aria-describedby={describedBy}
      aria-required={required}
      aria-invalid={error}
      sx={{ mb: 0 }}
    />
  );
};
